import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { InjectHtml } from '@/components/ui'
import type { IBannerWithLinkProps } from './interfaces'
import './bannerWithLink.scss'

const BannerWithLink: React.FC<IBannerWithLinkProps> = ({ contentTextId, linkTextId, link, className }) => (
  <section className={className}>
    <div className="banner-with-link page-wrapper">
      <InjectHtml textId={contentTextId} TagName="h4" />
      <CommonLink className="button button_white space-holder-top24-md" url={link}>
        <FormattedMessage id={linkTextId} />
      </CommonLink>
    </div>
  </section>
)

export default BannerWithLink
